// extracted by mini-css-extract-plugin
export var buttonWrapper = "advantages-hs-module--button-wrapper--b6ea8";
export var homeAdvantages = "advantages-hs-module--home-advantages--e0225";
export var underscore = "advantages-hs-module--underscore--2a4c7";